const isArray = maybeArray => maybeArray instanceof Array;

export { isArray };
